export default class CurrencyService {

  static apiRelativePath = "/currencies"

  constructor(apiClient) {
    this.apiClient = apiClient;
  }

  getAll = async () => {
    return this.apiClient.get(`${CurrencyService.apiRelativePath}`);
  }

  create = async (data) => {
    return this.apiClient.post(`${CurrencyService.apiRelativePath}`, data);
  }

  put = async (id, data) => {
    return this.apiClient.put(`${CurrencyService.apiRelativePath}/${id}`, data);
  }

  delete = async (id) => {
    return this.apiClient.delete(`${CurrencyService.apiRelativePath}/${id}`);
  }

  reorder = async (data) => {
    return this.apiClient.post(`${CurrencyService.apiRelativePath}/reorder`, data);
  }
}
